// import React, { useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Button,
//   TextField,
//   Typography,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   CircularProgress,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";
// import LockResetIcon from "@mui/icons-material/LockReset";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";


// const PatientTable = ({ patients, onDeleteSuccess, onPatientSelect }) => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [resetDialogOpen, setResetDialogOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//   const [patientToDelete, setPatientToDelete] = useState(null);
//   const [patientToReset, setPatientToReset] = useState(null);
// const accessToken= getDecryptedAccessToken()
//   const filteredPatients = patients?.filter(
//     (patient) =>
//       patient.fname.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       patient.email.toLowerCase().includes(searchQuery.toLowerCase())
//   ) || [];

//   const handleDeleteConfirm = async () => {
//     if (!patientToDelete) return;
//     setLoading(true);
  
//     try {
//       const response = await ApiServices.delete(`/apis/default/api/patient/${patientToDelete.pid}`, {
//        Authorization: `Bearer ${accessToken}` ,
//       });
  
  
//       if (response.status === 200 || response.status === 204) { // Check for success status codes
//         setSnackbar({ open: true, message: "Patient deleted successfully", severity: "success" });
//         onDeleteSuccess(); // Fetch updated patient list
//       } else {
//         throw new Error("Unexpected response from server");
//       }
//     } catch (error) {
//       console.error("Delete Error:", error); // Debugging log
//       setSnackbar({
//         open: true,
//         message: error.response?.data?.message || error.message || "Failed to delete patient",
//         severity: "error",
//       });
//       onDeleteSuccess();
//     } finally {
//       setLoading(false);
//       setDeleteDialogOpen(false);
//     }
//   };
  

//   const handleResetPasswordConfirm = async () => {
//     if (!patientToReset) return;
//     setLoading(true);
//     try {
//       await ApiServices.get(`/apis/default/api/usernamepasswordpatient/${patientToReset.pid}`,{
//         Authorization: `Bearer ${accessToken}`,
//       });
//       setSnackbar({ open: true, message: "Password reset successfully", severity: "success" });
//     } catch (error) {
//       setSnackbar({ open: true, message: error.response?.data?.message || "Failed to reset password", severity: "error" });
//     } finally {
//       setLoading(false);
//       setResetDialogOpen(false);
//     }
//   };

//   return (
//     <div>
//       <TextField
//         label="Search Patient"
//         variant="outlined"
//         fullWidth
//         margin="normal"
//         value={searchQuery}
//         onChange={(e) => setSearchQuery(e.target.value)}
//       />

//       <TableContainer component={Paper}>
//         <Table stickyHeader>
//           <TableHead>
//             <TableRow>
//               <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
//               <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
//               <TableCell sx={{ fontWeight: "bold" }}>Sex</TableCell>
//               <TableCell sx={{ fontWeight: "bold" }}>DOB</TableCell>
//               <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
//               <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
//               <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {filteredPatients.map((patient, index) => (
//               <TableRow key={patient.pid} hover onClick={() => onPatientSelect(patient)}>
//                 <TableCell>{index + 1}</TableCell>
//                 <TableCell>{`${patient.fname} ${patient.lname}`}</TableCell>
//                 <TableCell>{patient.sex || "N/A"}</TableCell>
//                 <TableCell>{patient.DOB || "N/A"}</TableCell>
//                 <TableCell>{patient.email || "N/A"}</TableCell>
//                 <TableCell>{patient.phone_contact || "N/A"}</TableCell>
//                 <TableCell>
//                   <IconButton color="error" onClick={(e) => { e.stopPropagation(); setPatientToDelete(patient); setDeleteDialogOpen(true); }}>
//                     <DeleteIcon />
//                   </IconButton>
//                   <Button
//                     size="small"
//                     variant="contained"
//                     color="primary"
//                     startIcon={<LockResetIcon />}
//                     onClick={(e) => { e.stopPropagation(); setPatientToReset(patient); setResetDialogOpen(true); }}
//                     sx={{ ml: 1 }}
//                   >
//                     Reset Password
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Deletion</DialogTitle>
//         <DialogContent>Are you sure you want to delete this patient?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleDeleteConfirm} color="error" disabled={loading}>
//             {loading ? <CircularProgress size={24} /> : "Delete"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={resetDialogOpen} onClose={() => setResetDialogOpen(false)}>
//         <DialogTitle>Confirm Password Reset</DialogTitle>
//         <DialogContent>Are you sure you want to reset this patient's password?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setResetDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleResetPasswordConfirm} color="primary" disabled={loading}>
//             {loading ? <CircularProgress size={24} /> : "Reset Password"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
//         <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// export default PatientTable;

import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Snackbar,
  Alert,
  Chip,
  Stack,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import LockResetIcon from "@mui/icons-material/LockReset";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const PatientTable = ({ patients, onDeleteSuccess, onPatientSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [resetDialogOpen, setResetDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [patientToDelete, setPatientToDelete] = useState(null);
  const [patientToReset, setPatientToReset] = useState(null);
  const accessToken = getDecryptedAccessToken();

  const filteredPatients =
    patients?.filter(
      (patient) =>
        patient.fname.toLowerCase().includes(searchQuery.toLowerCase()) ||
        patient.email.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  const handleDeleteConfirm = async () => {
    if (!patientToDelete) return;
    setLoading(true);

    try {
      const response = await ApiServices.delete(`/apis/default/api/patient/${patientToDelete.pid}`, {
        Authorization: `Bearer ${accessToken}`,
      });

      if (response.status === 200 || response.status === 204) {
        setSnackbar({ open: true, message: "Patient deleted successfully", severity: "success" });
        onDeleteSuccess();
      } else {
        throw new Error("Unexpected response from server");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || error.message || "Failed to delete patient",
        severity: "error",
      });
      onDeleteSuccess();
    } finally {
      setLoading(false);
      setDeleteDialogOpen(false);
    }
  };

  const handleResetPasswordConfirm = async () => {
    if (!patientToReset) return;
    setLoading(true);
    try {
      await ApiServices.get(`/apis/default/api/usernamepasswordpatient/${patientToReset.pid}`, {
        Authorization: `Bearer ${accessToken}`,
      });
      setSnackbar({ open: true, message: "Password reset successfully", severity: "success" });
    } catch (error) {
      setSnackbar({ open: true, message: error.response?.data?.message || "Failed to reset password", severity: "error" });
    } finally {
      setLoading(false);
      setResetDialogOpen(false);
    }
  };

  return (
    <div>
      <TextField
        label="Search Patient"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <TableContainer component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Sex</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>DOB</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredPatients.map((patient, index) => (
              <TableRow key={patient.pid} hover onClick={() => onPatientSelect(patient)}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{`${patient.fname} ${patient.lname}`}</TableCell>

                {/* Gender Chip */}
                <TableCell>
                  {patient.sex === "Male" ? (
                    <Chip icon={<MaleIcon />} label="Male" color="primary" variant="outlined" />
                  ) : patient.sex === "Female" ? (
                    <Chip icon={<FemaleIcon />} label="Female" color="secondary" variant="outlined" />
                  ) : (
                    "N/A"
                  )}
                </TableCell>

                {/* DOB with Icon */}
                <TableCell>
                  <Chip
                    icon={<CalendarTodayIcon />}
                    label={patient.DOB || "N/A"}
                    variant="outlined"
                  />
                </TableCell>

                {/* Email with Icon */}
                <TableCell>
                  <Chip icon={<EmailIcon />} label={patient.email || "N/A"} variant="outlined" />
                </TableCell>

                {/* Phone with Icon */}
                <TableCell>
                  <Chip icon={<PhoneIcon />} label={patient.phone_contact || "N/A"} variant="outlined" />
                </TableCell>

                {/* Actions */}
                <TableCell>
                  <Stack direction="column" spacing={1}>
                    {/* Delete Chip */}
                    <Chip
                     icon={<DeleteIcon />}
                      label="Delete"
                      color="error"
                      clickable
                      onClick={(e) => {
                        e.stopPropagation();
                        setPatientToDelete(patient);
                        setDeleteDialogOpen(true);
                      }}
                    />

                    {/* Reset Password Chip */}
                    <Chip
                      icon={<LockResetIcon />}
                      label="Reset Password"
                      color="primary"
                      clickable
                      onClick={(e) => {
                        e.stopPropagation();
                        setPatientToReset(patient);
                        setResetDialogOpen(true);
                      }}
                    />
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Delete Dialog */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>Are you sure you want to delete this patient?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reset Password Dialog */}
      <Dialog open={resetDialogOpen} onClose={() => setResetDialogOpen(false)}>
        <DialogTitle>Confirm Password Reset</DialogTitle>
        <DialogContent>Are you sure you want to reset this patient's password?</DialogContent>
        <DialogActions>
          <Button onClick={() => setResetDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleResetPasswordConfirm} color="primary" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "Reset Password"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
       <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
           {snackbar.message}
         </Alert>
       </Snackbar>
    </div>
  );
};

export default PatientTable;
